import {
  DashboardChecksTypeEnum as ApiDashboardChecksTypeEnum,
  DashboardProfileChecksResponseModel,
  DashboardProfileResponseModel,
  GetUserMessagesResponseModel,
  GetUserProfileAdminResponseModel,
  PhoneNumberInformationResponseModel,
  TransactionWithdrawDetailsViewModel,
  UserBusinessInformationAdminModel,
  UserLocalInfoResponseModel,
  UserMessageModel,
  UserPersonalInfoResponseModel,
  UserProfilePlanInfoResponseModel,
  UserShabaInfoResponseModel,
  UserSocialInfoResponseModel,
  UserVerificationTypeAdminEnum,
  UserVerificationTypeEnum,
  UserWizardStatusInfo,
  WageInfoViewModel,
} from "@payping/api";

import { LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";

export const SET_ACTIVE_REFERRAL = "SET_ACTIVE_REFERRAL";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_USER_WAGE = "SET_USER_WAGE";
export const SET_USER_DETAIL = "SET_USER_DETAIL";
export const SET_BUSINESS_INFO = "SET_BUSINESS_INFO";
export const SET_PERSONAL_INFO = "SET_PERSONAL_INFO";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_USER_CHECKS = "SET_USER_CHECKS";
export const SET_LOCAL_INFORMATION = "SET_LOCAL_INFORMATION";
export const SET_USER_PANEL_DATA = "SET_USER_PANEL_DATA";
export const SET_PHONE_NUMBER = "SET_PHONE_NUMBER";
export const SET_BANK = "SET_BANK";
export const SET_SOCIALS = "SET_SOCIALS";
export const SET_USER_WIZARD_INFO = "SET_USER_WIZARD_INFO";

export const SET_USER_MESSAGE_LIST = "SET_USER_MESSAGE_LIST";
export const SET_USER_MESSAGE_COUNT = "SET_USER_MESSAGE_COUNT";
export const READ_ALL_MESSAGES = "READ_ALL_MESSAGES";
export const SET_USER_WITHDRAW_STATUS = "SET_USER_WITHDRAW_STATUS";
export const SET_USER_OVERVIEW_TASKS_STATUS = "SET_USER_OVERVIEW_TASKS_STATUS";

export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";

export const SET_IS_LOADING_PERMISSIONS = "SET_IS_LOADING_PERMISSIONS";
export interface ConnectUserInfo {
  businessname: string;
  firstname: string;
  /* eslint-disable camelcase */
  /** Backend boolean notation. No way to change it due to third party authentication packages in backend */
  have_terminal: "True" | "False";
  is_oauth: boolean;
  ischecked_verification: boolean;
  /* eslint-enable camelcase */
  isverify: boolean;
  lastname: string;
  ppclientid: string;
  profilepicture: string;
  role?: string[];
  sub: string;
  username: string;
  paidFeature?: string[];
}

export interface UserState extends DashboardProfileResponseModel {
  personalInfo?: Omit<UserPersonalInfoResponseModel, "verifyType"> &
    Omit<GetUserProfileAdminResponseModel, "verifyType"> & {
      haveTerminal?: boolean;
      birthdayNationalCodeVerified?: boolean;
      name?: string;
      verifyType?: UserVerificationTypeEnum | UserVerificationTypeAdminEnum;
    };
  businessInfo?: UserBusinessInformationAdminModel;
  panelInfo?: UserProfilePlanInfoResponseModel &
    Pick<
      DashboardProfileResponseModel,
      | "isCurrentPanelPaid"
      | "isPendingPanelPaid"
      | "currentPlanId"
      | "panelBuyTime"
      | "panelEndTime"
      | "pendingPlanId"
      | "previousPlanId"
      | "previousPlan"
    >;
  bankInfo?: {
    sheba?: string;
    shebaVerified?: boolean;
  };
  localInfo?: UserLocalInfoResponseModel;
  message: {
    count: number;
    list: UserMessageModel[];
  };
  checks?: DashboardProfileChecksResponseModel;
  socials?: UserSocialInfoResponseModel;
  discountDays?: number;
  hasWithdraw?: boolean;
  autoWithdraw?: boolean;
  phoneNumber?: string;
  qrCode?: string;
  role?: string[];
  twoFactorEnabled?: boolean;
  wizard?: UserWizardStatusInfo;
  referralCode?: string;
  registerDateTime?: string;
  isReferralActive?: boolean;
  isSettlement?: boolean;
  wage?: WageInfoViewModel;
  permissions: string[];
  isLoadingPermission: boolean;
  overview: {
    hasWithdraw?: boolean;
    lastWithdraw?: TransactionWithdrawDetailsViewModel;
    tasksStatus?: {
      hasCoupon: boolean;
      hasCustomer: boolean;
      hasInvoices: boolean;
      hasProduct: boolean;
      hasToken: boolean;
      hasTransaction: boolean;
    };
  };
}

export interface SetUserInfoAction {
  type: typeof SET_USER_PROFILE;
  payload: GetUserProfileAdminResponseModel;
}

export interface SetUserPermissions {
  type: typeof SET_USER_PERMISSIONS;
  payload: UserState["permissions"];
}

export interface SetIsLoadingPermissions {
  type: typeof SET_IS_LOADING_PERMISSIONS;
  payload: UserState["isLoadingPermission"];
}

export interface SetUserProfileAction {
  type: typeof SET_USER_WAGE;
  payload: WageInfoViewModel;
}

export interface SetUserDetailAction {
  type: typeof SET_USER_DETAIL;
  payload: DashboardProfileResponseModel;
}

export interface SetBusinesInfoAction {
  type: typeof SET_BUSINESS_INFO;
  payload: UserBusinessInformationAdminModel;
}

export interface SetPersonalInfoAction {
  type: typeof SET_PERSONAL_INFO;
  payload: UserPersonalInfoResponseModel;
}

export interface SetUserRoleAction {
  type: typeof SET_USER_INFO;
  payload: ConnectUserInfo;
}

export interface SetUserChecksAction {
  type: typeof SET_USER_CHECKS;
  payload: DashboardProfileChecksResponseModel;
}

export interface SetLocalInformationAction {
  type: typeof SET_LOCAL_INFORMATION;
  payload: UserLocalInfoResponseModel;
}

export interface SetUserPanelDataAction {
  type: typeof SET_USER_PANEL_DATA;
  payload: UserProfilePlanInfoResponseModel;
}

export interface SetPhoneNumberAction {
  type: typeof SET_PHONE_NUMBER;
  payload: PhoneNumberInformationResponseModel;
}

export interface SetBankAction {
  type: typeof SET_BANK;
  payload: UserShabaInfoResponseModel;
}

export interface SetSocialsAction {
  type: typeof SET_SOCIALS;
  payload: UserSocialInfoResponseModel;
}

export interface SetUserWizardInfoAction {
  type: typeof SET_USER_WIZARD_INFO;
  payload: UserWizardStatusInfo;
}

export interface SetUserMessageListAction {
  type: typeof SET_USER_MESSAGE_LIST;
  payload: GetUserMessagesResponseModel;
}

export interface SetUserMessageCountAction {
  type: typeof SET_USER_MESSAGE_COUNT;
  payload: number;
}

export interface ReadAllMessagesAction {
  type: typeof READ_ALL_MESSAGES;
}

export interface SetActiveReferral {
  type: typeof SET_ACTIVE_REFERRAL;
}
export interface SetUserWithdrawStatusAction {
  type: typeof SET_USER_WITHDRAW_STATUS;
  payload: {
    hasWithdraw?: UserState["overview"]["hasWithdraw"];
    lastWithdraw?: UserState["overview"]["lastWithdraw"];
  };
}
export interface SetUserOverviewTasksStatus {
  type: typeof SET_USER_OVERVIEW_TASKS_STATUS;
  payload: UserState["overview"]["tasksStatus"];
}

export type UserActionTypes =
  | SetUserInfoAction
  | SetUserPermissions
  | SetUserProfileAction
  | SetIsLoadingPermissions
  | SetUserDetailAction
  | SetBusinesInfoAction
  | SetPersonalInfoAction
  | SetUserRoleAction
  | SetUserChecksAction
  | ClearListAction
  | SetLocalInformationAction
  | SetPhoneNumberAction
  | SetBankAction
  | SetSocialsAction
  | SetUserWizardInfoAction
  | SetUserMessageListAction
  | SetUserMessageCountAction
  | ReadAllMessagesAction
  | SetUserPanelDataAction
  | SetActiveReferral
  | LoggedOutAction
  | SetUserWithdrawStatusAction
  | SetUserOverviewTasksStatus;

// TODO: this enum should be deleted & imported from @payping/api, but jest can't run with that
// Issue: https://github.com/kulshekhar/ts-jest/issues/944
const DashboardChecksTypeEnum: Record<string, ApiDashboardChecksTypeEnum> = {
  AdminPending: 1,
  Confirmed: 2,
  NotFilled: 0,
};

const initialState: UserState = {
  bankInfo: {
    sheba: undefined,
    shebaVerified: false,
  },
  checks: {
    bNationalCodeStatus: DashboardChecksTypeEnum.NotFilled,
    bankStatus: DashboardChecksTypeEnum.NotFilled,
    businessStatus: DashboardChecksTypeEnum.NotFilled,
    emailStatus: DashboardChecksTypeEnum.NotFilled,
    isSiteRequired: false,
    localStatus: DashboardChecksTypeEnum.NotFilled,
    percentComplete: 0,
    personalStatus: DashboardChecksTypeEnum.NotFilled,
    phoneNumberStatus: DashboardChecksTypeEnum.NotFilled,
    siteStatus: DashboardChecksTypeEnum.NotFilled,
    socialsStatus: DashboardChecksTypeEnum.NotFilled,
    taxStatus: DashboardChecksTypeEnum.NotFilled,
    telegramStatus: DashboardChecksTypeEnum.NotFilled,
  },
  hasWithdraw: undefined,
  // It is better to hide modal (`isReferralActive: true`) and other stuff for referral unless make sure the user has not seen it before
  isLoadingPermission: false,
  isReferralActive: true,
  localInfo: {},
  message: {
    count: 0,
    list: [],
  },
  overview: {
    hasWithdraw: undefined,
  },
  permissions: [],
  personalInfo: {
    birthdayNationalCodeVerified: false,
  },
  role: [],
};

export default function user(state = initialState, action: UserActionTypes): UserState {
  if (action.type === SET_ACTIVE_REFERRAL) {
    return {
      ...state,
      isReferralActive: true,
    };
  }

  if (action.type === SET_USER_PERMISSIONS) {
    return {
      ...state,
      permissions: action.payload,
    };
  }
  if (action.type === SET_IS_LOADING_PERMISSIONS) {
    return {
      ...state,
      isLoadingPermission: action.payload,
    };
  }

  if (action.type === SET_USER_PROFILE) {
    const { firstName, lastName, ...otherPayload } = action.payload;

    return {
      ...state,
      personalInfo: {
        ...state.personalInfo,
        ...otherPayload,
        name: `${firstName} ${lastName}`,
      },
    };
  }

  if (action.type === SET_USER_WAGE) {
    return {
      ...state,
      personalInfo: {
        ...state.personalInfo,
      },
      wage: action.payload,
    };
  }

  if (action.type === SET_USER_DETAIL) {
    const {
      businessName,
      emailConfirmed,
      firstName,
      id,
      lastName,
      profilePicture,
      username,
      verifyType,
      currentPlan,
      currentPlanId,
      planExpireDate,
      pendingPlan,
      previousPlan,
      previousPlanId,
      pendingPlanId,
      invoiceCode,
      isCurrentPanelPaid,
      isPendingPanelPaid,
      panelBuyTime,
      panelEndTime,
      ...otherPayload
    } = action.payload;

    return {
      ...state,
      businessInfo: {
        ...state.businessInfo,
        businessName,
      },
      panelInfo: {
        ...state.panelInfo,
        currentPlan,
        currentPlanId,
        invoiceCode,
        isCurrentPanelPaid,
        isPendingPanelPaid,
        panelBuyTime,
        panelEndTime,
        pendingPlan,
        pendingPlanId,
        planExpireDate,
        previousPlan,
        previousPlanId,
      },
      personalInfo: {
        ...state.personalInfo,
        // emailVerified: emailConfirmed,
        emailConfirmed,
        firstName,
        id,
        lastName,
        profilePicture,
        username,
        verifyType,
      },
      ...otherPayload,
    };
  }

  if (action.type === SET_BUSINESS_INFO) {
    return {
      ...state,
      businessInfo: {
        ...state.businessInfo,
        ...action.payload,
      },
    };
  }

  if (action.type === SET_PERSONAL_INFO) {
    return {
      ...state,
      personalInfo: {
        ...state.personalInfo,
        ...action.payload,
      },
    };
  }

  if (action.type === SET_USER_INFO) {
    /* eslint-disable camelcase */
    const { role, profilepicture, username, firstname, lastname, sub, have_terminal } = action.payload;
    return {
      ...state,
      personalInfo: {
        ...state.personalInfo,
        firstName: firstname,
        haveTerminal: have_terminal === "True",
        id: parseInt(sub, 10),
        lastName: lastname,
        profilePicture: profilepicture,
        username,
      },
      role,
    };
    /* eslint-enable camelcase */
  }

  if (action.type === SET_USER_CHECKS) {
    return { ...state, checks: { ...state.checks, ...action.payload } };
  }

  if (action.type === SET_LOCAL_INFORMATION) {
    return { ...state, localInfo: { ...state.localInfo, ...action.payload } };
  }

  if (action.type === SET_USER_PANEL_DATA) {
    return { ...state, panelInfo: { ...state.panelInfo, ...action.payload } };
  }

  if (action.type === SET_PHONE_NUMBER) {
    const { phoneNumber } = action.payload;

    return { ...state, personalInfo: { ...state.personalInfo, phoneNumber } };
  }

  if (action.type === SET_BANK) {
    const { shabaVerifyed, shaba } = action.payload;
    return {
      ...state,
      bankInfo: {
        ...state.bankInfo,
        sheba: shaba,
        shebaVerified: shabaVerifyed,
      },
    };
  }

  if (action.type === SET_SOCIALS) {
    return { ...state, socials: action.payload };
  }

  if (action.type === SET_USER_WIZARD_INFO) {
    return { ...state, wizard: { ...action.payload } };
  }

  if (action.type === SET_USER_MESSAGE_LIST) {
    const { count, messages } = action.payload;
    return { ...state, message: { count: count || 0, list: messages || [] } };
  }

  if (action.type === SET_USER_MESSAGE_COUNT) {
    const count = action.payload;
    return { ...state, message: { ...state.message, count } };
  }

  if (action.type === READ_ALL_MESSAGES) {
    const newMsgList = state.message.list.map((msg) => ({ ...msg, isSeen: true }));
    return { ...state, message: { ...state.message, list: newMsgList } };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  if (action.type === SET_USER_WITHDRAW_STATUS) {
    return {
      ...state,
      overview: {
        ...state.overview,
        hasWithdraw: action.payload.hasWithdraw,
        lastWithdraw: action.payload.lastWithdraw,
      },
    };
  }

  if (action.type === SET_USER_OVERVIEW_TASKS_STATUS) {
    return {
      ...state,
      overview: {
        ...state.overview,
        tasksStatus: action.payload,
      },
    };
  }

  return state;
}
